import React from "react";
import Quotation from "./quotation";
class QuotationParent extends React.Component {
    render() {
        return <Quotation />;
    }
}
export default QuotationParent;
